import {
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  AfterViewInit
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatTab } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { IncidentRegelSetStatus } from '../models/IncidentRegelSetStatus';
import { Regel } from '../models/Regel';
import { RegelSet } from '../models/RegelSet';
import { RegelSetActie } from '../models/RegelSetActie';
import { RegelsService } from '../services/regels.service';
import { genericSortingAccessor } from '../shared.module';
import { RegelSetDialogComponent } from './dialogs/regel-set-dialog.component';

@Component({
  selector: 'app-beheer-regels',
  templateUrl: './beheer-regels.component.html',
  styleUrls: ['./beheer-regels.component.scss']
})
export class BeheerRegelsComponent implements OnInit {
  dataSourceRegelSet = new MatTableDataSource<RegelSet>();
  displayedColumnsRegelSet: string[] = ['regelSetId', 'naam', 'action'];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChildren(MatTable) matTableRegelSet: MatTable<RegelSet>;

  constructor(
    private router: Router,
    private regelsSvc: RegelsService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.refreshDataSourceRegelSet();
  }

  refreshDataSourceRegelSet(): void {
    this.regelsSvc.loadRegelSets().subscribe((o) => {
      this.dataSourceRegelSet.data = o;
      this.dataSourceRegelSet.sort = this.sort;
      this.dataSourceRegelSet.sortingDataAccessor = genericSortingAccessor;
    });
  }

  clickHandler(row) {
    this.router.navigateByUrl(`regelSetDetails/${row.regelSetId}`);
    console.log(row);
  }

  openDialog(action, obj) {
    obj.action = action;
    let dialogRef = this.dialog.open(RegelSetDialogComponent, {
      width: '60%',
      maxWidth: 'fit-content',
      data: obj
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.event == 'Toevoegen') {
          this.addRowData(result.data);
        } else if (result.event == 'Bewerken') {
          this.updateRowData(result.data);
        } else if (result.event == 'Verwijderen') {
          this.deleteRowData(result.data);
        }
      }
    });
  }

  addRowData(row_obj) {
    console.log('Add');
    console.log(row_obj);
    const i: RegelSet = {
      regelSetId: 0,
      naam: row_obj.naam
    };

    this.regelsSvc.saveRegelSet(i).subscribe(
      (r) => {
        const changeData = this.dataSourceRegelSet.data;
        this.dataSourceRegelSet.data = changeData.concat(r);
        this.router.navigateByUrl(`regelSetDetails/${r.regelSetId}`);
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }
  updateRowData(row_obj) {
    console.log('edit');
    console.log(row_obj);

    const i: RegelSet = {
      regelSetId: row_obj.regelSetId,
      naam: row_obj.naam
    };

    this.regelsSvc.saveRegelSet(i).subscribe(
      (r) => {
        const changeData = this.dataSourceRegelSet.data;
        const foundIndex = changeData.findIndex(
          (x) => x.regelSetId === r.regelSetId
        );
        changeData[foundIndex] = r;
        this.dataSourceRegelSet.data = changeData;
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }
  deleteRowData(row_obj) {
    console.log('delete ');
    console.log(row_obj);

    const i: RegelSet = {
      regelSetId: row_obj.regelSetId,
      naam: row_obj.naam
    };

    this.regelsSvc.deleteRegelSet(i.regelSetId).subscribe(
      (r) => {
        this.refreshDataSourceRegelSet();
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }

  showErrorToast(error: any, melding: string) {
    let tekst = melding;

    if (error.message) {
      tekst += '(' + error.message + ')';
    }

    this.snackBar.open(tekst, null, { duration: 3000 });
  }
}
